import { useState } from "react";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";
import { BulkSiloModalContainer } from "..";

export interface BulkSiloContainerProps {
    selectedRows?: Array<{ id: number }>;
}
const BulkSiloContainer = (props: BulkSiloContainerProps) => {
    const { selectedRows = [] } = props;

    const [showModal, setShowModal] = useState(false);

    const { formatMessage } = useIntl();

    const hasSelectedRows = selectedRows.length > 0;

    return (
        <>
            <Button disabled={!hasSelectedRows} onClick={() => setShowModal(true)}>
                {formatMessage({ id: "common.button.silo" })}
            </Button>
            {showModal && hasSelectedRows && (
                <BulkSiloModalContainer
                    selectedRowsId={selectedRows?.map((el) => el.id)}
                    handleClose={() => setShowModal(false)}
                    openModal={showModal}
                />
            )}
        </>
    );
};

export default BulkSiloContainer;
